import { Vue, Component } from 'vue-property-decorator';
import { DisplayEnum } from '@/types/enum';
import { SearchParams } from '@/types/product';
import { convertProductUri, getLocalStorageMalls, toI18n } from '@/utils/commonUtils';
import { Mall, ContractedPartner, ProductsSearch } from 'supporter';
import { RadioRenderer } from '@/utils/commonUtils';

@Component
export default class ExchangeProductDataMixin extends Vue {
  public keywordTexthide: boolean = true;
  public keywordCheck: boolean = false;

  public mallInfo: Mall[] = getLocalStorageMalls();
  public additionalDiscount: string = 'ALL';
  private additionalDiscountRadioOptions = {
    name: 'additionalDiscount',
    data: [
      {
        id: 'additionalDiscountYn',
        value: 'ALL',
        dispaly: 'CLAIM_EXCHANGEPRODUCT_ADDITIONALDISCOUNT_ALL',
      },
      {
        id: 'additionalDiscountY',
        value: 'Y',
        dispaly: 'CLAIM_EXCHANGEPRODUCT_ADDITIONALDISCOUNT_ALL',
      },
      {
        id: 'additionalDiscountN',
        value: 'N',
        dispaly: 'CLAIM_EXCHANGEPRODUCT_ADDITIONALDISCOUNT_ALL',
      },
    ],
  };
  private get partnerName(): any {
    let partnerInfo: ContractedPartner | undefined;
    partnerInfo = this.partnerList.find(
      (partnerInfo): any => partnerInfo.partnerNo == Number(this.routeQuery.partnerNo),
    );
    if (partnerInfo) {
      return partnerInfo.partnerName;
    }
    return '';
  }

  private get mallList(): any {
    let list: any = [];
    if (this.mallInfo) {
      this.mallInfo.forEach((mall): any => {
        list.push({
          value: mall.mallNo,
          name: mall.mallName,
        });
      });
    }
    return list;
  }

  public mallNo!: string;
  public categoiesCascade: any;
  public partnerList: ContractedPartner[] = [];
  public searchType: DisplayEnum[] = [
    { value: 'MALL_PRODUCT_NO', label: this.toI18n('CLAIM_EXCHANGEPRODUCT_MALLPRODUCTNO') },
    { value: 'PRODUCT_NAME', label: this.toI18n('CLAIM_EXCHANGEPRODUCT_PRODUCTNAME') },
  ];
  public searchRespones: ProductsSearch = {
    contents: [],
    totalPage: 0,
    totalCount: 0,
  };
  public keyTextArea?: string;
  public searchParams: SearchParams = {
    mallNos: '',
    'keywordInfo.type': 'MALL_PRODUCT_NO',
    'keywordInfo.keywords': '',
    brandNo: -100,
    partnerNo: -100,
    adminNo: -100,
    applyStatusType: 'ALL',
    //'saleStatus.isAll': false,
    'saleStatus.types': '',
    'saleSettingStatus.isAll': false,
    'saleSettingStatus.types': '',
    'categoryCondition.type': 'DISPLAY',
    'categoryCondition.depth': '',
    'categoryCondition.no': '',
    'stockRange.type': '',
    'stockRange.stockCnt': -1,
    allowsPromotion: 'ALL',
    allowsFrontDisplay: 'ALL',
    additionalDiscountYn: 'ALL',
    platformType: 'ALL',
    saleMethodType: 'ALL',
    hasAdditionalDiscount: 'ALL',
    'commission.type': 'ALL',
    'commission.range.min': 0,
    'commission.range.max': 100,
    customPropertyValueNos: '',
    'periodInfo.type': 'REGISTER_DATE',
    'periodInfo.period.startYmdt': '1970-01-01 00:00:00',
    'periodInfo.period.endYmdt': '2999-12-31 23:59:59',
    page: 1,
    size: 100,
  };

  public searchParamsBack: SearchParams = {
    mallNos: '',
    'keywordInfo.type': 'MALL_PRODUCT_NO',
    'keywordInfo.keywords': '',
    brandNo: -100,
    partnerNo: -100,
    adminNo: -100,
    applyStatusType: 'ALL',
    //'saleStatus.isAll': false,
    'saleStatus.types': '',
    'saleSettingStatus.isAll': false,
    'saleSettingStatus.types': '',
    'categoryCondition.type': 'DISPLAY',
    'categoryCondition.depth': '',
    'categoryCondition.no': '',
    'stockRange.type': '',
    'stockRange.stockCnt': -1,
    allowsPromotion: 'ALL',
    allowsFrontDisplay: 'ALL',
    additionalDiscountYn: 'ALL',
    platformType: 'ALL',
    saleMethodType: 'ALL',
    hasAdditionalDiscount: 'ALL',
    'commission.type': 'ALL',
    'commission.range.min': 0,
    'commission.range.max': 100,
    customPropertyValueNos: '',
    'periodInfo.type': 'REGISTER_DATE',
    'periodInfo.period.startYmdt': '1970-01-01 00:00:00',
    'periodInfo.period.endYmdt': '2999-12-31 23:59:59',
    page: 1,
    size: 100,
  };

  public routeQuery = {
    // addAllConfirm: '',
    addConfirm: '',
    // additionalDiscount: '',
    // allBtn: '',
    callBackName: '',
    // callbackParam: '',
    // coupon: '',
    // couponTarget: '',
    // customProperty: '',
    // description: '',
    // displayCategoryInfo: '',
    emptyAlert: '',
    // exceptedTarget: '',
    // hideDesc: '',
    limit: '',
    // noCheckMallProductNos: '',
    // reverse: '',
    // target: '',
    mallNo: '',
    partnerNo: '',
    // addSelectedBtn: this.$t('CLAIM_EXCHANGEPRODUCT_ADDSELECTEDBTN'),
    // addAllBtn: '검색결과 전체 추가',
    // cancelBtn: this.$t('CLAIM_EXCHANGEPRODUCT_CLOSE'),
  };

  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t(needToI18nStr));
  }

  public productDetailUrl: string = '';
  public getProductDetailUrl({ value }: any): string {
    return `<a target="_blank" href="${convertProductUri(this.productDetailUrl, value)}">${value}</a>`;
  }
  public gridProps = {
    columns: [
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_MALLNAME'),
        name: 'mallName',
        align: 'center',
        minWidth: 100,
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_MALLPRODUCTNO'),
        name: 'mallProductNo',
        align: 'center',
        minWidth: 100,
        formatter: this.getProductDetailUrl,
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_PRODUCTNAME'),
        name: 'productName',
        align: 'center',
        minWidth: 200,
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_SALEMETHODTYPE'),
        name: 'saleMethodType',
        minWidth: 130,
        align: 'center',
        formatter: ({ row }: any) => {
          switch (row.saleMethodType) {
            case 'ALL':
              return this.toI18n('CLAIM_EXCHANGEPRODUCT_SALEMETHODTYPEALL');
            case 'PURCHASE':
              return this.toI18n('CLAIM_EXCHANGEPRODUCT_SALEMETHODTYPEPURCHASE');
            case 'CONSIGNMENT':
              return this.toI18n('CLAIM_EXCHANGEPRODUCT_SALEMETHODTYPECONSIGNMENT');
            default:
              return '';
          }
        },
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_PARTNERNM'),
        name: 'partnerName',
        minWidth: 130,
        align: 'center',
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_ADMINNAME'),
        name: 'adminName',
        align: 'center',
        minWidth: 100,
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_COMMISSIONRATE'),
        name: 'commissionRate',
        align: 'center',
        minWidth: 130,
        formatter: ({ row }: any): string => {
          return `${row.commission.rate}%`;
        },
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_APPLIEDADDITIONALDISCOUNTPRICE'),
        name: 'appliedImmediateDiscountPrice',
        minWidth: 130,
        align: 'right',
        formatter: function(cell: any): any {
          if (cell.row.appliedImmediateDiscountPrice == null || isNaN(cell.row.appliedImmediateDiscountPrice)) {
            return 0;
          }
          return cell.row.appliedImmediateDiscountPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_ADDITIONALDISCOUNTAMOUNT'),
        name: 'additionalDiscountAmount',
        minWidth: 130,
        align: 'center',
        formatter: function(cell: any): any {
          if (cell.row.additionalDiscountAmount == null || isNaN(cell.row.additionalDiscountAmount)) {
            return 0;
          }
          return cell.row.additionalDiscountAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_APPLYDISCOUNTPRICE'),
        name: 'appliedAdditionalDiscountPrice',
        minWidth: 130,
        align: 'center',
      },
      {
        header: this.toI18n('CLAIM_EXCHANGEPRODUCT_ADDITIONALDISCOUNTNAME'),
        minWidth: 130,
        name: 'additionalDiscountName',
        align: 'center',
      },
    ],
    options: {
      rowHeaders: [
        {
          type: 'radio',
          header: this.toI18n('ADMIN_LIST_SELECT'), // 선택
          renderer: RadioRenderer,
        },
      ],
      pageOptions: {
        page: 1,
        totalCount: 0,
        perPage: 100,
      },
    },
  };

  public gridOptions?: { [propName: string]: any } = {
    // columnOptions: {
    //   minWidth: 70,
    //   frozenCount: 3
    // },
    haveConfigBtn: false,
    //bodyHeight: 400,
    // bodyHeight: 700,
    //rowHeight: 31,
    virtualScrolling: true,
    //minRowHeight: 31,
    // keyColumnName: 'mallProductNo',!!!!!!!!!!!!!scroll grid data issue!!!!
    //displayRowCount: 20,
    //isInitialRequest: false,
    //useClientSort: false,
    //heightResizable: true
    // under props need further confirmation!!!!!!
    // pagination: {
    //   itemsPerPage: $('#pageSize').val(),
    //   visiblePages: 10
    // }
  };

  public contentBottomOption = {
    name: 'product_search_grid',
    onLoadSearch: false,
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    pageSize: '100',
  };
}
